// extracted by mini-css-extract-plugin
export default {"input_wrapper":"NewExtraData_input_wrapper__x-sYG"};